export default "__VITE_ASSET__BTB3nS0O__"